import { render, staticRenderFns } from "./LinkInput.vue?vue&type=template&id=71f7c082&"
import script from "./LinkInput.vue?vue&type=script&lang=ts&"
export * from "./LinkInput.vue?vue&type=script&lang=ts&"
import style0 from "./LinkInput.vue?vue&type=style&index=0&id=71f7c082&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports